// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"682fb57f","429":"75765230","453":"2be523f7","495":"65f7173f","745":"962b8937"}[chunkId] + ".chunk.js";
};